import { createStore, Effect } from 'effector';

import { applyReducers } from '@m/effector-utils';
import { Site, SiteMap } from '@m/types/api';

import { getSites } from './actions';

import type { DoneHandler } from '@m/effector-utils';
import type { APIResponse } from '@m/utils/http';

export type State = {
  siteMap: SiteMap;
  sites: Site[];
};

export const initialState: State = {
  sites: [],
  siteMap: {},
};

const store = createStore(initialState);

type Reducers = {
  getSites: {
    action: Effect<Parameters<typeof getSites>[0], APIResponse>;
    done: DoneHandler<Parameters<typeof getSites>[0], State>;
  };
};

function siteMapReduce(map: SiteMap, site: Site): SiteMap {
  return {
    ...map,
    [site.id]: site,
  };
}

export const reducers: Reducers = {
  getSites: {
    action: getSites,
    done: (state, { result: { success, data } = {} }) => ({
      ...state,
      sites: success ? data : state.sites,
      siteMap: success ? data.reduce(siteMapReduce, {}) : state.siteMap,
    }),
  },
};

export default applyReducers({ storeName: 'admin/site', store, reducers });
